/**
 * Product information tabs — event-delegated, multi-instance safe.
 * Tab groups are rendered by pdp-block-product-tabs.liquid from
 * consecutive product_tab_* section blocks.
 */
(function () {
  if (window.__wtProductTabsInit) return;
  window.__wtProductTabsInit = true;

  function activate(container, index) {
    const headers = container.querySelectorAll(".wt-product-tabs__header");
    const panels = container.querySelectorAll(".wt-product-tabs__panel");
    headers.forEach((h, i) => {
      const on = i === index;
      h.classList.toggle("is-active", on);
      h.setAttribute("aria-selected", on ? "true" : "false");
      h.tabIndex = on ? 0 : -1;
    });
    panels.forEach((p, i) => p.classList.toggle("is-active", i === index));
  }

  function refreshCollapsibleToggles(container) {
    container.querySelectorAll("[data-tab-toggle]").forEach((toggle) => {
      const panel = toggle.closest(".wt-product-tabs__panel");
      if (!panel || !panel.classList.contains("is-active")) {
        toggle.hidden = true;
        return;
      }
      const collapsible = panel.querySelector(".wt-product-tabs__text--collapsible");
      if (!collapsible) {
        toggle.hidden = true;
        return;
      }
      const inner = collapsible.querySelector("[data-tab-text-inner]");
      const collapsedHeight = parseInt(collapsible.dataset.collapsedHeight, 10) || 120;
      toggle.hidden = inner.scrollHeight <= collapsedHeight + 4;
    });
  }

  function setCollapsedState(toggle, expanded) {
    const panel = toggle.closest(".wt-product-tabs__panel");
    const collapsible = panel && panel.querySelector(".wt-product-tabs__text--collapsible");
    if (!collapsible) return;
    collapsible.classList.toggle("is-collapsed", !expanded);
    collapsible.classList.toggle("is-expanded", expanded);
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    const label = toggle.querySelector("[data-tab-toggle-label]");
    if (label) label.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
  }

  document.addEventListener("click", (e) => {
    const toggle = e.target.closest("[data-tab-toggle]");
    if (toggle) {
      const expanded = toggle.getAttribute("aria-expanded") !== "true";
      setCollapsedState(toggle, expanded);
      return;
    }

    const header = e.target.closest(".wt-product-tabs__header");
    if (!header) return;
    const container = header.closest(".wt-product-tabs");
    if (!container) return;
    activate(container, parseInt(header.dataset.tabIndex, 10) || 0);
    requestAnimationFrame(() => refreshCollapsibleToggles(container));
  });

  // Roving tabindex + arrow-key navigation (WAI-ARIA tabs pattern)
  document.addEventListener("keydown", (e) => {
    const header = e.target.closest && e.target.closest(".wt-product-tabs__header");
    if (!header) return;
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "Home" && e.key !== "End") return;

    const container = header.closest(".wt-product-tabs");
    const headers = Array.from(container.querySelectorAll(".wt-product-tabs__header"));
    const current = headers.indexOf(header);
    let next = current;

    if (e.key === "ArrowRight") next = (current + 1) % headers.length;
    if (e.key === "ArrowLeft") next = (current - 1 + headers.length) % headers.length;
    if (e.key === "Home") next = 0;
    if (e.key === "End") next = headers.length - 1;

    e.preventDefault();
    activate(container, next);
    headers[next].focus();
    requestAnimationFrame(() => refreshCollapsibleToggles(container));
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".wt-product-tabs").forEach((container) => refreshCollapsibleToggles(container));
  });
})();
